import macro from 'vtk.js/Sources/macros';
import vtkInteractorStyleTrackballCamera from "vtk.js/Sources/Interaction/Style/InteractorStyleTrackballCamera";
import vtkInteractorStyleManipulator from 'vtk.js/Sources/Interaction/Style/InteractorStyleManipulator';

// ----------------------------------------------------------------------------
// customTrackballInteractor methods
// ----------------------------------------------------------------------------
function customTrackballInteractor(publicAPI, model) {

    // Set our className
    model.classHierarchy.push('customTrackballInteractor');

    // Public API methods
    publicAPI.baseSuperHandleKeyPress = publicAPI.handleKeyPress;
    publicAPI.handleKeyPress = callData => {
        switch (callData.key) {
            case 'r':
            case 'R':
            case 'w':
            case 'W':
            case 's':
            case 'S':
            case 'v':
            case 'V':
                break;
            default:
                publicAPI.baseSuperHandleKeyPress(callData);
                break;
        }
    };

    publicAPI.setMouseWheelIsSliceScroll = (isSliceScroll) => {
        model.isSliceScroll = isSliceScroll;
    };

    publicAPI.setIsMouseWheelScrollEnabled = (isMouseWheelScrollEnabled) => {
        model.isMouseWheelScrollEnabled = isMouseWheelScrollEnabled;
    };

    publicAPI.setUpdateSliceMethod = (updateSlice) => {
        model.updateSlice = updateSlice;
    };

    publicAPI.setIsStentPlanning = (isStentPlanning) => {
        model.isStentPlanning = isStentPlanning;
    };

    publicAPI.setOnMouseRotated = (updateAngle) => {
        model.updateAngle = updateAngle;
    };

    publicAPI.setScrollFactor = (scrollFactor) => {
        model.scrollFactor = scrollFactor;
    };

    publicAPI.setOnCameraChanged = (onCameraChanged) => {
        model.onCameraChanged = onCameraChanged;
    };

    publicAPI.baseSuperHandleMouseWheel = publicAPI.handleMouseWheel;
    publicAPI.handleMouseWheel = (callData) => {
        if (model.isStentPlanning || !model.isMouseWheelScrollEnabled) {
            return;
        } else if (model.isSliceScroll) {
            model.updateSlice(callData.spinY * model.scrollFactor);
        } else {
            const dyf = 1 - callData.spinY / model.zoomFactor;
            vtkInteractorStyleManipulator.dollyToPosition(
                dyf,
                callData.position,
                model.getRenderer(callData),
                model._interactor
            );
            if (model.onCameraChanged) {
                model.onCameraChanged();
            }
        }
    };

    publicAPI.baseSuperHandleMouseRotate = publicAPI.handleMouseRotate;
    publicAPI.handleMouseRotate = (renderer, position) => {
        if (model.isStentPlanning) {
            return;
        } else {
            publicAPI.baseSuperHandleMouseRotate(renderer, position);

            model.updateAngle();
            if (model.onCameraChanged) {
                model.onCameraChanged();
            }
        }
    };

    publicAPI.baseSuperHandleMouseSpin = publicAPI.handleMouseSpin;
    publicAPI.handleMouseSpin = (renderer, position) => {
        if (model.isStentPlanning) {
            return;
        } else {
            publicAPI.baseSuperHandleMouseSpin(renderer, position);
            if (model.onCameraChanged) {
                model.onCameraChanged();
            }
        }
    };

    publicAPI.baseSuperHandleMousePan = publicAPI.handleMousePan;
    publicAPI.handleMousePan = (renderer, position) => {
        if (model.isStentPlanning) {
            return;
        } else {
            publicAPI.baseSuperHandleMousePan(renderer, position);
            if (model.onCameraChanged) {
                model.onCameraChanged();
            }
        }
    };

    // This fixes a weird bug where moving the mouse while moving the scroll buttons
    // actually causes the dolly to move
    publicAPI.baseSuperHandleMouseDolly = publicAPI.handleMouseDolly;
    publicAPI.handleMouseDolly = () => { };
}

// ----------------------------------------------------------------------------
// Object factory
// ----------------------------------------------------------------------------

const DEFAULT_VALUES = {
    isMouseWheelScrollEnabled: true,
    scrollFactor: 2
};

// ----------------------------------------------------------------------------

export function extend(publicAPI, model, initialValues = {}) {
    Object.assign(model, DEFAULT_VALUES, initialValues);

    // Inheritance
    vtkInteractorStyleTrackballCamera.extend(publicAPI, model, initialValues);

    // Create get-set macros
    macro.setGet(publicAPI, model, ['interactionMode']);

    // For more macro methods, see "Sources/macros.js"

    // Object specific methods
    customTrackballInteractor(publicAPI, model);
}

// ----------------------------------------------------------------------------

export const newInstance = macro.newInstance(extend, 'customTrackballInteractor');

// ----------------------------------------------------------------------------

export default { newInstance, extend };